<template>
  <div>
    <v-container>
      <v-row v-if="$route.name === 'media_center'">
        <v-col cols="12">
          <section class="file-upload__gallery mt-2">
            <multi-image-upload
              class="file-upload__gallery--upload"
              :maxSize="maxSize"
              @fileSelected="handleMultiPhotos"
              @handle_delete_image="handleDelteImag"
              :imgsUrl="media_photos"
            />
          </section>
        </v-col>
        <v-col cols="12">
          <section class="file-upload__gallery mt-2">
            <VideoUpload
              :videosFiles="media_videos"
              @set_videos="onSetVideos"
            />
          </section>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-row>
            <template v-for="fieldName in formKeys">
              <v-col cols="12" :key="fieldName">
                <Editor
                  :locale="locale"
                  :form="form"
                  :fieldName="fieldName"
                />
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { StoreData } from "@/helpers/apiMethods";

export default {
  name: "MediaCenter",
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    locale: {
      type: String,
      default: ""
    },
    mediaVideos: {
      type: Array,
      default: () => []
    },
    mediaPhotos: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Editor: () => import("@/components/Editor"),
    VideoUpload: () => import("@/components/VideoUpload")
  },
  data() {
    return {
      maxSize: 2.48
    };
  },

  computed: {
    formKeys() {
      return Object.keys(this.form);
    },
    media_photos() {
      return this.mediaPhotos;
    },
    media_videos() {
      return this.mediaVideos;
    }
  },
  methods: {
    onSetVideos(videos) {
      this.handleSubmit("media_videos", videos);
    },
    handleMultiPhotos(photos) {
      this.handleSubmit("media_photos", photos);
    },
    handleDelteImag(index) {
      this.media_photos.splice(index, 1);
    },
    handleSubmit(fieldName, files) {
      const formData = new FormData();
      files.forEach(item => {
        formData.append(`${fieldName}[]`, item);
      });
      formData.append("locale", this.locale);
      formData.append("page_name", this.$route.name);

      StoreData({ reqName: "page-settings", data: formData }).then(res => {
        const { setting } = res.data;
        const mediaFile = setting.find(el => el.type === fieldName);
        this.$emit("update_medila_files", fieldName, mediaFile.value);
      });
    }
  }
};
</script>

